import {
  FaFutbol,
  FaMoneyBillWave,
  FaBell,
  FaMoon,
  FaSun,
  FaGlobeAmericas,
} from 'react-icons/fa';
import { getLandingsByType, getLandingLeagueId } from '../../data/landingsConfig';
import { pageHeaders } from '../../data/pageHeadersConfig';
import {
  getPredictionBookmakerSlugs,
  getBookieDisplayName,
} from '../bookmakers/config/bookmakerSelectors';

export const REGIONAL_BONUSES = [
  { id: 'bangladesh', title: 'Bangladesh', countryCode: 'BD', to: '/bonuses-bangladesh' },
  { id: 'india', title: 'India', countryCode: 'IN', to: '/bonuses-india' },
  { id: 'pakistan', title: 'Pakistan', countryCode: 'PK', to: '/bonuses-pakistan' },
  { id: 'nepal', title: 'Nepal', countryCode: 'NP', to: '/bonuses-nepal' },
  { id: 'nigeria', title: 'Nigeria', countryCode: 'NG', to: '/bonuses-nigeria' },
  { id: 'kenya', title: 'Kenya', countryCode: 'KE', to: '/bonuses-kenya' },
  { id: 'cameroon', title: 'Cameroon', countryCode: 'CM', to: '/bonuses-cameroon' },
  { id: 'ethiopia', title: 'Ethiopia', countryCode: 'ET', to: '/bonuses-ethiopia' },
  { id: 'ghana', title: 'Ghana', countryCode: 'GH', to: '/bonuses-ghana' },
  { id: 'philippines', title: 'Philippines', countryCode: 'PH', to: '/bonuses-philippines' },
  { id: 'tanzania', title: 'Tanzania', countryCode: 'TZ', to: '/bonuses-tanzania' },
  { id: 'uganda', title: 'Uganda', countryCode: 'UG', to: '/bonuses-uganda' },
];

const shortenLandingTitle = (title) =>
  title
    .replace(' Predictions Today', '')
    .replace(' Predictions', '')
    .replace(' Tips', '');

const buildLeagueItems = () =>
  getLandingsByType('league').map((landing) => ({
    id: landing.slug,
    type: 'link',
    title: shortenLandingTitle(landing.title),
    description: landing.subtitle,
    to: `/${landing.slug}`,
    leagueId: getLandingLeagueId(landing),
  }));

const buildBetTypeItems = () =>
  getLandingsByType('betType').map((landing) => ({
    id: landing.slug,
    type: 'link',
    title: shortenLandingTitle(landing.title),
    description: landing.subtitle,
    to: `/${landing.slug}`,
    icon: landing.icon,
  }));

const buildBookmakerItems = () => {
  const items = [
    {
      id: 'best-betting-sites',
      type: 'link',
      title: 'Best Betting Sites',
      description: pageHeaders.bestBettingSites.subtitle,
      to: '/best-betting-sites',
      icon: FaMoneyBillWave,
    },
  ];

  getPredictionBookmakerSlugs().forEach((slug) => {
    const name = getBookieDisplayName(slug);
    if (!name) return;
    items.push({
      id: `${slug}-predictions`,
      type: 'link',
      title: `${name} Predictions`,
      description: `Tips filtered for ${name}`,
      to: `/${slug}-predictions`,
      icon: FaFutbol,
    });
  });

  return items;
};

const buildRegionalItems = () =>
  REGIONAL_BONUSES.map((region) => ({
    id: region.id,
    type: 'link',
    title: region.title,
    description: 'Regional welcome bonuses',
    to: region.to,
    countryCode: region.countryCode,
  }));

/**
 * @param {{ onNotifications: () => void }} actions
 */
export const buildMenuSections = (actions) => [
  {
    id: 'main',
    title: 'Navigation',
    collapsible: false,
    compact: true,
    items: [
      { id: 'predictions', type: 'link', title: 'Predictions', description: pageHeaders.home.subtitle, to: '/', end: true, icon: pageHeaders.home.icon },
      {
        id: 'results',
        type: 'link',
        title: 'Results',
        description: pageHeaders.results.subtitle,
        to: '/results',
        icon: pageHeaders.results.icon,
      },
      {
        id: 'accumulators',
        type: 'link',
        title: 'Accumulators',
        description: pageHeaders.accumulators.subtitle,
        to: '/accumulators/',
        icon: pageHeaders.accumulators.icon,
      },
      {
        id: 'bonuses',
        type: 'link',
        title: 'Bonuses',
        description: pageHeaders.bonuses.subtitle,
        to: '/bookie-bonuses/',
        icon: pageHeaders.bonuses.icon,
      },
      {
        id: 'guides',
        type: 'link',
        title: 'Guides',
        description: pageHeaders.guides.subtitle,
        to: '/betting-guides/',
        icon: pageHeaders.guides.icon,
      },
    ],
  },
  {
    id: 'leagues',
    title: 'Leagues',
    collapsible: true,
    defaultOpen: false,
    items: buildLeagueItems(),
  },
  {
    id: 'markets',
    title: 'Betting Markets',
    collapsible: true,
    defaultOpen: false,
    items: buildBetTypeItems(),
  },
  {
    id: 'bookmakers',
    title: 'Bookmakers',
    collapsible: true,
    defaultOpen: false,
    items: buildBookmakerItems(),
  },
  {
    id: 'regions',
    title: 'Bonuses by Region',
    collapsible: true,
    defaultOpen: false,
    items: buildRegionalItems(),
  },
  {
    id: 'tools',
    title: 'Tools',
    collapsible: false,
    items: [
      {
        id: 'notifications',
        type: 'action',
        title: 'Notification Settings',
        description: 'Alerts & preferences',
        icon: FaBell,
        action: 'notifications',
      },
      {
        id: 'theme',
        type: 'theme',
        title: 'Dark Mode',
        description: 'Toggle light / dark theme',
        iconDark: FaMoon,
        iconLight: FaSun,
      },
    ],
  },
  {
    id: 'disclaimer',
    title: '',
    collapsible: false,
    items: [
      {
        id: 'responsible',
        type: 'note',
        title: '18+ Please gamble responsibly.',
        icon: FaGlobeAmericas,
      },
    ],
  },
];
